import productSlider from '../components/product-slider'

export default {
	namespace: 'product',
	beforeEnter() {

	},
	afterEnter(barba) {

		// Product thumbnail/hero selector logic:
		productSlider(barba)
		let thumbs = document.querySelectorAll('.product-gallery-thumb')
		let galleryHero = document.getElementById('galleryHero')
		function heroLoaded() {
			console.log('hero img loaded')
		}

		if (galleryHero.complete) {
			heroLoaded()
		} else {
			galleryHero.addEventListener('load', heroLoaded)
			galleryHero.addEventListener('error', function () {
				console.log('error loading hero image')
			})
		}

		for (let i = 0; i < thumbs.length; i++) {
			thumbs[i].addEventListener('click', function () {
				galleryHero.classList.remove('loaded')
				galleryHero.src = thumbs[i].dataset.src
				galleryHero.dataset.full = thumbs[i].dataset.full
			});
		}
		// EOF hero/thumbs

	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
